import React from 'react';
import './LogoAndLinks.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const LogoAndLinks: React.FC = () => {
  const variants = {
    initial: {
      opacity: 0,
      scale: 2,         // Reduced from 3 to minimize overflow
      filter: 'blur(20px)',
      y: "50vh",
    },
    animate: {
      opacity: 1,
      scale: 1,
      filter: 'blur(0px)',
      y: "0vh",
      transition: {
        duration: 1.5,
        ease: "easeInOut",
      },
    },
  };


  return (
    <div className="logo-and-links" style={{ overflow: 'hidden' }}>
      <motion.div
        className="site-title"// Apply the styles
        variants={variants}
        initial="initial"
        animate="animate"
        style={{ position: 'relative' }}
      >
        <span>Simplistic Creations</span>
      </motion.div>
      <motion.div
        variants={variants}
        initial="initial"
        animate="animate"
        style={{ position: 'relative' }}
      >
        <nav>
          <Link to="/photography">Photography</Link> <span className="divider"> | </span>
          <Link to="/software-engineering">Software Engineering</Link><span className="divider"> | </span>
          <Link to="/music">Music</Link>
        </nav>
      </motion.div>
    </div>
  );
};

export default LogoAndLinks;